import React from 'react';
import { GridCustomHeaderCellProps } from '@progress/kendo-react-grid';
import { filterIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { HeaderThElement } from '@progress/kendo-react-data-tools';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

interface HeaderCellProps extends GridCustomHeaderCellProps {
  compositeFilterDescriptor?: CompositeFilterDescriptor;
}

export const HeaderCell = (props: HeaderCellProps) => {
  const { thProps, children, compositeFilterDescriptor } = props;

  const filteredField = compositeFilterDescriptor
    ? (compositeFilterDescriptor?.filters as Array<CompositeFilterDescriptor>).find(
        filter => filter && filter.filters.length > 0 && (filter.filters[0] as FilterDescriptor).field === props.field
      )
    : null;

  return (
    <HeaderThElement
      columnId={thProps?.columnId || ''}
      style={thProps?.style}
      className={thProps?.className}
      colSpan={thProps?.colSpan}
      rowSpan={thProps?.rowSpan}
      role={thProps?.role}
      aria-colindex={thProps?.['aria-colindex']}
      onClick={thProps?.onClick}
      onContextMenu={thProps?.onContextMenu}
    >
      <span className="columnHeader">
        {filteredField && compositeFilterDescriptor && <SvgIcon className="filterIcon" icon={filterIcon} />}
        {children}
      </span>
    </HeaderThElement>
  );
};
